import api from 'lib/trpcClient';

export default function useSearchInvestors(
  query: string,
  vehicleId?: string,
  exactMatch?: boolean,
) {
  const { data, isFetching } = api.onboarding.searchInvestors.useQuery(
    {
      query,
      vehicleId: vehicleId ?? '',
      exactMatch,
    },
    {
      enabled: !!query && !!vehicleId,
    },
  );

  return {
    investors: query ? data ?? [] : [],
    isFetching: query ? isFetching : false,
  };
}
